import { useAuthContext } from "../../core/contexts/AuthContextProvider";

const useAuthority = (module) => {
  const { fetchAuthorityForModule } = useAuthContext();

  return fetchAuthorityForModule?.(module) || {};
};

export default useAuthority;
